// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.evaluacion-container {
  width: 100%;
  min-height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 100px;
}

.evaluacion-content {
  width: 80%;
  max-width: 800px;
  text-align: center;
  font-family: 'Roboto', sans-serif;
  margin-top: 50px;
}

.evaluacion-content h1 {
  font-style: normal;
  font-weight: bold;
  font-size: 55px;
  text-align: center;
  color: #047da2;
  margin-top: 20px;
  margin-bottom: 30px;
}

.evaluacion-content p {
  font-size: 20px;
  margin-bottom: 30px;
}

.iniciar-evaluacion-button {
  background-color: #047da2;
  color: white;
  padding: 15px 30px;
  border: none;
  cursor: pointer;
  border-radius: 32px;
}

@media (max-width: 768px) {
  .evaluacion-content h1 {
    font-size: 35px;
  }

  .evaluacion-content p {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Evaluations/EvaluationPage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".evaluacion-container {\n  width: 100%;\n  min-height: calc(100vh - 100px);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-bottom: 100px;\n}\n\n.evaluacion-content {\n  width: 80%;\n  max-width: 800px;\n  text-align: center;\n  font-family: 'Roboto', sans-serif;\n  margin-top: 50px;\n}\n\n.evaluacion-content h1 {\n  font-style: normal;\n  font-weight: bold;\n  font-size: 55px;\n  text-align: center;\n  color: #047da2;\n  margin-top: 20px;\n  margin-bottom: 30px;\n}\n\n.evaluacion-content p {\n  font-size: 20px;\n  margin-bottom: 30px;\n}\n\n.iniciar-evaluacion-button {\n  background-color: #047da2;\n  color: white;\n  padding: 15px 30px;\n  border: none;\n  cursor: pointer;\n  border-radius: 32px;\n}\n\n@media (max-width: 768px) {\n  .evaluacion-content h1 {\n    font-size: 35px;\n  }\n\n  .evaluacion-content p {\n    font-size: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
